import React from "react";
import styles from "./search.module.scss";
import SearchTeam from "../searchTeam/searchTeam";

const Search:React.FC = () =>{

    return(
        <>
            <div className={styles.csTeamSearchSearchBackground}>
                <div className={styles.csTeamSearchSiteWidth}>
                    <SearchTeam />
                </div>
            </div>
        </>
    )

};

export default Search;